import {stringify} from 'qs'
import {format} from 'utils'
import request from 'crm/utils/request'
import api from 'crm/common/api/material'

export async function list(params) {
    return request(`${api.list.url}?${stringify(params)}`)
}

export async function create(payload) {
    return request(api.create.url, {
        method: api.create.type,
        body: payload.body,
    })
}

export async function batchCreate(payload) {
    return request(api.batchCreate.url, {
        method: api.batchCreate.type,
        body: payload.body,
    })
}

export async function update(payload) {
    return request(`${format(api.update.url, {id: payload.id})}`, {
        method: api.update.type,
        body: payload.body,
    })
}

export async function remove(payload) {
    return request(`${format(api.remove.url, {id: payload.id})}`, {
        method: api.remove.type,
    })
}

// 批量删除素材
export async function batchRemove(payload) {
    return request(`${api.batchRemove.url}?${stringify(payload)}`, {
        method: api.batchRemove.type,
    })
}

// 分组
export async function groups() {
    return request(api.groups.url)
}

export async function createGroup(payload) {
    return request(api.createGroup.url, {
        method: api.createGroup.type,
        body: payload.body,
    })
}

export async function updateGroup(payload) {
    return request(`${format(api.updateGroup.url, {id: payload.id})}`, {
        method: api.updateGroup.type,
        body: payload.body,
    })
}

export async function removeGroup(payload) {
    return request(`${format(api.removeGroup.url, {id: payload.id})}`, {
        method: api.removeGroup.type,
    })
}
// 批量分组
export async function batchGroup(payload) {
    return request(api.batchGroup.url, {
        method: api.batchGroup.type,
        body: payload.body,
    })
}

// 批量设置可见范围
export async function batchShare(payload) {
    return request(api.batchShare.url, {
        method: api.batchShare.type,
        body: payload.body,
    })
}

// 获取网页信息
export async function webPageInfo(payload) {
    return request(api.webPageInfo.url, {
        method: api.webPageInfo.type,
        body: payload.body,
    })
}

// 获取小程序
export async function mpa() {
    return request(api.mpa.url)
}
